import { BaseEntity, int } from "./base.model";

export interface Question extends BaseEntity {
  id: string;
  name: string;
  type: QuestionTypeEnum;
  content: string;
  options: QuestionOption[];
}

export interface QuestionOption {
  key: string;
  label: string;
  subOptions?: QuestionOption[];
}

export enum QuestionTypeEnum {
  "datePicker" = "datePicker",
  "dateTimePicker" = "dateTimePicker",
  "singleVerticalRadio" = "singleVerticalRadio",
  "singleHorizontalRadio" = "singleHorizontalRadio",
  "dropdown" = "dropdown",
  "multipleCheckbox" = "multipleCheckbox",
  "imageVideo" = "imageVideo",
  "textInput" = "textInput",
  "multipleDropdown" = "multipleDropdown",
  "multipleRowColumnRadio" = "multipleRowColumnRadio",
}
